__turbopack_context__.v({
  "tradeIn": "styles-module-scss-module__9D-NzG__tradeIn",
  "tradeInFlex": "styles-module-scss-module__9D-NzG__tradeInFlex",
  "tradeInVerticalSteps": "styles-module-scss-module__9D-NzG__tradeInVerticalSteps",
});
